import {
  PATH_DASHBOARD,
  PATH_HISTORY,
  PATH_LOTTERY,
  PATH_LIMITED_STAKE,
  PATH_STAKE
} from "./paths";
import { SettingsView } from "../views/NewDashboard";
import MainLayout from "../layouts/NewMainLayout";
import ActivityHistoryLayout from "../layouts/ActivityHistoryLayout";
import StakeLayout from "../layouts/StakeLayout";
import LotteryLayout from "../layouts/LotteryLayout";
import LimitedStakeLayout from "../layouts/LimitedStakeLayout";
import { Referral, Rewards, Transfer, ReferralDetails } from "../views/Dashboard/History";
import { Pools, MyPositions } from "../views/Dashboard/Stake";
import { LimitedPools, LimitedMyPositions } from "../views/Dashboard/LimitedStake";
import { LotteryPool, LotteryMyTickets, LotteryReferral } from "../views/Dashboard/Lottery";
import { Redirect } from "react-router-dom";
import LoyaltyProgram from "../views/Dashboard/LoyaltyProgram";
import { HomeView, TradeView } from "../views/NewDashboard";

const DashboardRoutes = {
  layout: MainLayout,
  routes: [
    {
      path: PATH_DASHBOARD.root,
      exact: true,
      component: () => <HomeView />
    },
    {
      path: PATH_DASHBOARD.root,
      exact: true,
      component: () => <HomeView />
    },
    {
      path: PATH_DASHBOARD.settingsView,
      exact: true,
      component: () => <SettingsView />
    },
    {
      path: PATH_DASHBOARD.tradeView,
      exact: true,
      component: () => <TradeView />
    },
    {
      component: () => <Redirect to={PATH_DASHBOARD.root} />
    }
  ]
};

export default DashboardRoutes;
